import VueGtag from "vue-gtag-next";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueGtag, {
        property: {
            id: "G-5QS6HVVC68",
        },
        params: {
            send_page_view: true,
        },
    });
});
